import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { CustomSelect } from 'src/components'
import { ProjectStageType } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { projectFormStateSelector, setProjectFormItemValue } from 'src/features'

const ProjectCertificationStageFormItem: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { is_active } = useAppSelector(projectFormStateSelector)

  const options = [
    { value: 'waiting_verification', label: t('Forward.Waiting') },
    { value: 'in_validation', label: t('Forward.InValidation') },
    { value: 'pilot_phase', label: t('Forward.PilotPhase') },
  ]

  return (
    <CustomSelect
      name='stage'
      placeholder={t('Forward.StagePlaceholder')}
      onChange={(value: ProjectStageType) => dispatch(setProjectFormItemValue({ key: 'stage', value }))}
      required={is_active}
    >
      {options.map(option => (
        <Select.Option
          key={option.value}
          value={option.value}
        >
          {option.label}
        </Select.Option>
      ))}
    </CustomSelect>
  )
}

export default ProjectCertificationStageFormItem
